export default __webpack_public_path__ + "static/media/thaiger.cb6de3ad.svg";